import { axiosClient } from "./axios";
import { API_ROUTES } from "../constants/apiRoutes";
import { CartItem } from "../types/common";

interface AddToCartResponse {
  success?: boolean;
  message: string;
  code?: string;
  data?: OrderItem[];
}

interface OrderItem {
  uuid: string;
  product_id: string;
  order_id: string;
  amount: string;
  offering_id: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string | null;
  counter_name: string;
  package_id: string;
  status: string;
  day_quota: string;
}

export const getCart = async (customerId: string) => {
  const res = await axiosClient.post(API_ROUTES.GET_CART, {
    cus_id: customerId,
  });
  return res.data;
};

export interface Root {
  cus_id: string;
  package_order: PackageOrder[];
}

export interface PackageOrder {
  package_uuid: string;
  qty: number;
}

export const addToCart = async (
  customerId: string,
  items: CartItem[]
): Promise<AddToCartResponse> => {
  const res = await axiosClient.post(API_ROUTES.ADD_TO_CART, {
    cus_id: customerId,
    package_order: items.map((item) => ({
      package_uuid: item.packageId,
      qty: item.quantity,
    })),
  });
  return res.data;
};

export const removeFromCart = async (
  orderId: string,
  orderDetailId: string
) => {
  return axiosClient.delete(API_ROUTES.REMOVE_FROM_CART, {
    data: {
      orderId,
      orderDetailId,
    },
  });
};

export const clearCart = async (customerId: string) => {
  return axiosClient.delete(API_ROUTES.CLEAR_CART, {
    data: { cus_id: customerId },
  });
};
